<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-go-up`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.971 7.56738C12.2304 7.30773 12.2304 6.88562 11.971 6.62598L8.47095 3.12598C8.21133 2.86635 7.78926 2.8665 7.52955 3.12598L4.02955 6.62598C3.76985 6.88568 3.76985 7.30769 4.02955 7.56738C4.28926 7.8269 4.71131 7.82702 4.97095 7.56738L7.33521 5.20313L7.33521 12.4053C7.33521 12.7725 7.63298 13.0703 8.00025 13.0703C8.36734 13.0701 8.66529 12.7724 8.66529 12.4053L8.66529 5.20313L11.0295 7.56738C11.2893 7.8269 11.7113 7.82702 11.971 7.56738Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineGoUp',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
